// facets-custom.js

function facetCheckboxClick(event) {

    event.preventDefault();
    event.stopPropagation();

    const facetCheckbox = event.target.closest('.facet-checkbox');

    if (!facetCheckbox) return;

    const filterForm = event.target.closest('form');
    const filterCheckbox = facetCheckbox.querySelector('input[type="checkbox"]');

    if (!filterForm || !filterCheckbox) return;

    // Keep the UI responsive while redirecting for custom filters.
    filterCheckbox.checked = !filterCheckbox.checked;

    const redirectPath = getRedirectPath(filterForm, filterCheckbox);

    window.location.href = redirectPath;
}

function getRedirectPath(filterForm, filterCheckbox) {

    const filterName = filterCheckbox.getAttribute('paramname');
    
    /* ----------------------------------------------------------------------------- */

    if (filterName.startsWith('subcollection')) {

        return `${window.ShopifyMegatree.route}/${filterCheckbox.value.replace(/\s+/g, "-").toLowerCase()}`;
    }
    
    /* ----------------------------------------------------------------------------- */

    if (filterName.startsWith('multitag')) {

        return `${window.ShopifyMegatree.url}/${filterCheckbox.value.replace(/\s+/g, "-").toLowerCase()}`;
    }
    
    /* ----------------------------------------------------------------------------- */
            
    let redirectPath = window.ShopifyMegatree.url;

    if (filterName.startsWith('filter.p.m')) {

        const currentTags = window.ShopifyMegatree.currentTags || [];
        const currentTag = currentTags.join('+');
        
        /* ----------------------------------------------------------------------------- */

        const inputTags = {};
        const inputFilters = {};
        const searchParams = {};
        
        /* ----------------------------------------------------------------------------- */

        filterForm.querySelectorAll('input[type="checkbox"]:checked').forEach(input => {

            if (currentTags.includes(input.value)) {

                window.ShopifyMegatree.meta[input.value]?.friendly_seo === '1' ?
                inputTags[input.value] = input.getAttribute('paramname') ?? input.name :
                inputFilters[input.value] = input.getAttribute('paramname') ?? input.name;
            }
        });

        filterForm.querySelectorAll('input[type="checkbox"]:checked').forEach(input => {

            if (!currentTags.includes(input.value)) {

                window.ShopifyMegatree.meta[input.value]?.friendly_seo === '1' ?
                inputTags[input.value] = input.getAttribute('paramname') ?? input.name :
                inputFilters[input.value] = input.getAttribute('paramname') ?? input.name;
            }
        });
        
        /* ----------------------------------------------------------------------------- */

        if (inputTags[filterCheckbox.value] || inputFilters[filterCheckbox.value]) {

            if (inputTags[filterCheckbox.value]) {

                delete inputTags[filterCheckbox.value];
            }

            if (inputFilters[filterCheckbox.value]) {

                delete inputFilters[filterCheckbox.value];
            }
        } else {
                        
            window.ShopifyMegatree.meta[filterCheckbox.value]?.friendly_seo === '1' ?
            inputTags[filterCheckbox.value] = filterName :
            inputFilters[filterCheckbox.value] = filterName;
        }

        /* ----------------------------------------------------------------------------- */        

        const filterSortBy = document.querySelector('[name="sort_by"]');

        if (filterSortBy) {

            searchParams[`sort_by=${filterSortBy.value}`] = `sort_by=${filterSortBy.value}`;
        }

        document.querySelectorAll('form').forEach(form => {

            const filters = form.querySelectorAll('input[name^="filter"]:not([name^="filter.p.m"]):not(:disabled)');

            filters.forEach(filter => {

                if (filter.type === 'checkbox' || filter.type === 'radio') {

                    if (filter.checked) {

                        searchParams[`${filter.name}=${filter.value}`] = `${filter.name}=${filter.value}`;
                    }
                } else {
                    
                    searchParams[`${filter.name}=${filter.value}`] = `${filter.name}=${filter.value}`;
                }
            });
        });

        /* ----------------------------------------------------------------------------- */

        const multiTag = findMultiTag(Object.keys(inputTags));

        if (multiTag) {

            multiTag.tags.forEach(value => {

                delete inputTags[value];
            });

            redirectPath =`${redirectPath}/${multiTag.tag.replace(/\s+/g, "-").toLowerCase()}`;   

            if (Object.keys(inputTags).length > 0) {

                Object.entries(inputTags).forEach(([value, key]) => {

                    searchParams[`${key}=${value}`] = `${key}=${value}`;
                });
            }

            if (Object.keys(inputFilters).length > 0) {

                Object.entries(inputFilters).forEach(([value, key]) => {

                    searchParams[`${key}=${value}`] = `${key}=${value}`;
                });
            }
        } else {
                    
            if (inputTags[currentTag] && currentTag === filterCheckbox.value) {

                delete inputTags[currentTag];
            }
            
            if (Object.keys(inputTags).length > 0) {

                let index = 0;
                
                Object.entries(inputTags).forEach(([key, value]) => {

                    if (index === 0) {
            
                        redirectPath = `${redirectPath}/${key.replace(/\s+/g, "-").toLowerCase()}`;
                    } else {

                        inputFilters[key] = value;
                    }

                    index++;
                });
            }

            if (Object.keys(inputFilters).length > 0) {

                Object.entries(inputFilters).forEach(([value, key]) => {

                    searchParams[`${key}=${value}`] = `${key}=${value}`;
                });
            }
        }

        if (Object.keys(searchParams).length > 0) {
        
            redirectPath = `${redirectPath}?${Object.values(searchParams).join('&')}`;
        }

        return redirectPath;
    }

    return redirectPath;
}

function findMultiTag(tags) {

    let bestMatch = null;
    let maxCount = -1;

    for (const [key, data] of Object.entries(window.ShopifyMegatree.meta)) {
        
        if (data.multi !== "1") continue;

        const isSubset = data.multi_tags.every(tag => tags.includes(tag));

        if (isSubset) {

            if (data.multi_tags.length > maxCount) {

                maxCount = data.multi_tags.length;

                bestMatch = { tag: key, tags: data.multi_tags };
            }
        }
    }

    return bestMatch;
}